import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import toast from "react-hot-toast";
import { authActions } from "../../redux/store";
import eraseCookie from "../../helper/eraseCookie";
import getCookie from "../../helper/getCookie";

const AccountSidebar = () => {

  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      navigate("/login");
      // localStorage.clear();
      eraseCookie('token')

    } catch (error) {
      console.log(error);
    }
  };

  const isActive = (path) => {
    return window.location.pathname === path ? 'active' : '';
  };

  return (
    <>


      <div className="col-lg-3 my-lg-0 my-md-1">
        <div id="sidebar" className="bg-white border pb-0 overflow-hidden">
          
     

          <div className="h4 text-dark d-flex justify-content-between align-items-center">Account
 <a
      className="btn btn-primary me-4 d-md-none d-inline-block"
      data-bs-toggle="collapse"
      href="#collapseExample"
      role="button"
      aria-expanded="false"
      aria-controls="collapseExample"
    >
      Menu
    </a>

          </div>


 <div className="collapse d-md-block bg-light border-top" id="collapseExample">

          <ul  >


            {isLogin &&
              <li className={isActive('/account')} >
                <Link
                  to="/account"
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">My Account</div>
                    <div className="link-desc">
                      View &amp; Manage orders and returns
                    </div>
                  </div>
                </Link>
              </li>
            }

            

         
            {/* {isLogin &&
              <li className={isActive('/account/all-transactions')} >
                <Link
                  to="/account/all-transactions"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">All Payments</div>
                    <div className="link-desc">
                      My all payments
                    </div>
                  </div>
                </Link>
              </li>
            } */}

            
            {/* {isLogin &&
              <li className={isActive('/account/all-video-call')} >
                <Link
                  to="/account/all-video-call"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link"> Video Calls</div>
                    <div className="link-desc">
                      My All Video Calls
                    </div>
                  </div>
                </Link>
              </li>
            } */}


{/* 
{isLogin &&
              <li className={isActive('/account/all-medical')} >
                <Link
                  to="/account/all-medical"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">All Medical</div>
                    <div className="link-desc">
                      My all medical
                    </div>
                  </div>
                </Link>
              </li>
            } */}

{isLogin &&
              <li className={isActive('/account/all-order')} >
                <Link
                  to="/account/all-order"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">All Bookings</div>
                    <div className="link-desc">
                      My all Bookings
                    </div>
                  </div>
                </Link>
              </li>
            }

            {isLogin &&
              <>
                <li className={isActive('/account/profile')} >
                  <Link
                    to="/account/profile"
                    className="text-decoration-none d-flex align-items-start"
                  >
                    <div className="far fa-address-book pt-2 me-3" />
                    <div className="d-flex flex-column">
                      <div className="link">My Profile</div>
                      <div className="link-desc">  Change your profile details</div>
                    </div>
                  </Link>
                </li>

                {/* <li className={isActive('/account/profile-kyc')} >
                  <Link
                    to="/account/profile-kyc"
                    className="text-decoration-none d-flex align-items-start"
                  >
                    <div className="far fa-address-book pt-2 me-3" />
                    <div className="d-flex flex-column">
                      <div className="link"> Health Profile</div>
                      <div className="link-desc">  Change your  personal health profile</div>
                    </div>
                  </Link>
                </li> */}



              </>

            }

            {/* <li className={isActive('/wishList')} >
              <Link
                to="/wishList"
                className="text-decoration-none d-flex align-items-start"
              >
                <div className="far fa-address-book pt-2 me-3" />
                <div className="d-flex flex-column">
                  <div className="link">My wishlist</div>
                  <div className="link-desc">  Choose your wishList</div>
                </div>
              </Link>
            </li> */}


            {/* <li className={isActive('/comparsion')} >
              <Link
                to="/comparsion"
                className="text-decoration-none d-flex align-items-start"
              >
                <div className="far fa-address-book pt-2 me-3" />
                <div className="d-flex flex-column">
                  <div className="link">My comparsion</div>
                  <div className="link-desc">  Compare your products details</div>
                </div>
              </Link>
            </li> */}

            {isLogin &&
              <li className={isActive('/account/password')} >
                <Link
                  to="/account/password"
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="far fa-user pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Change Password</div>
                    <div className="link-desc">
                      Change your profile password
                    </div>
                  </div>
                </Link>
              </li>
            }

            {isLogin &&
              <li className={isActive('/account/support')} >
                <Link
                  to="/account/support"
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-headset pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Help &amp; Support</div>
                    <div className="link-desc">
                      Contact Us for help and support
                    </div>
                  </div>
                </Link>
              </li>
            }

            {isLogin &&
              <li   >
                <Link
                  onClick={handleLogout}
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-headset pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Logout </div>
                    <div className="link-desc">
                      Logout your account
                    </div>
                  </div>
                </Link>
              </li>
            }



          </ul>
  </div>


        </div>
      </div>



    </>
  )
}

export default AccountSidebar